import { hideProp } from "./hideProp";
export function Enumerable(enumerable = true) {
  return function (target, key) {
    let desc = Object.getOwnPropertyDescriptor(target, key);
    if (desc) {
      desc.enumerable = enumerable;
      return desc;
    }
    desc = {
      set(val) {
        hideProp(this, key, {
          value: val,
          enumerable: false,
          writable: true
        });
      },
      get() {
        return;
      },
      enumerable: false,
      configurable: true
    };
    return desc;
  };
}
export const NotEnumerable = Enumerable(false);
//# sourceMappingURL=enumerable.js.map
